<template>
    <v-app-bar class="px-2 toolbar-overflow" color="surface" variant="flat" height="60">
        <v-app-bar-nav-icon v-if="$vuetify.display.mobile" @click.stop="toggleSidebar" />

        <router-link to="/" exact class="d-flex align-center ml-4" :style="{ cursor: 'pointer' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 574 157" fill="currentColor"
                style="height: 1.575rem; width: auto;">
                <path d="M22 21V61H82V82H22V140H0V104C0 91.8497 9.84974 82 22 82V61H0V0H98V21H22Z" />
                <path d="M214.023 140H146.023V120H180.023H214.023V140Z" />
                <path d="M124.023 0V98C124.023 110.15 133.873 120 146.023 120V0H124.023Z" />
                <path
                    d="M367.64 0L439.111 85.1756H413.003L367 140H393.108L439.111 85.1756L485.114 140H511.223L452.165 69.6184L510.582 0H484.474L439.111 54.0611L393.749 0H367.64Z" />
                <path
                    d="M348.031 98C348.031 110.15 338.182 120 326.031 120V140L274.053 140C249.756 140 230.058 120.307 230.053 96.0098L230.031 0H252.031V98C252.031 110.15 261.881 120 274.031 120H326.031V0H348.031V98Z" />
            </svg>
        </router-link>

        <search class="ml-2 flex-shrink-1" />

        <v-spacer />

        <v-tooltip text="Documentation" location="bottom">
            <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon variant="text" href="https://docs.fluxoutdoor.com/docs" target="_blank">
                    <v-icon>$docs</v-icon>
                </v-btn>
            </template>
        </v-tooltip>

        <user-dropdown />
    </v-app-bar>
</template>

<script>
import eventBus from "../eventBus";
import UserDropdown from "./UserDropdown.vue";
import Search from "./Search.vue";

export default {
    components: {
        UserDropdown,
        Search,
    },
    methods: {
        toggleSidebar() {
            eventBus.emit("TOGGLE_SIDEBAR");
        },
    },
};
</script>

<style>
.toolbar-overflow .v-toolbar__content {
    overflow: visible;
}
</style>
